export const selectedTheme = () => {
  return {
    primaryColor: "#182bda",
    secondaryColor: "#4051eb",
    lightColor: "#ebebfa",
    darkColor: "#020A4F",
  }
};
